import { render, staticRenderFns } from "./TypeRentCreateUpdate.vue?vue&type=template&id=87f0be48&"
import script from "./TypeRentCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TypeRentCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports